import React from 'react';
import { Dialog, DialogContent, Typography, Button } from '@material-ui/core';
import StarsIcon from '@material-ui/icons/Stars';
import './premiumAttemptsDialog.scss';

interface IPremiumAttemptsDialogProps {
    open: boolean;
    remaining: number;
    onClose: () => void;
    onContinue: () => void;
    onSubscribe: () => void;
}

// Shown when a non-subscribed user opens a PREMIUM test while they still have
// metered free attempts left (pool comes from the backend's
// premium-attempts-status endpoint). Once the pool is empty the screens show
// the SubscriptionDialog instead of this.
export const PremiumAttemptsDialog = ({ open, remaining, onClose, onContinue, onSubscribe }: IPremiumAttemptsDialogProps) => (
    <Dialog open={open} onClose={onClose} className="premium-attempts-dialog" aria-labelledby="premium-attempts-title">
        <DialogContent className="premium-attempts-content">
            <StarsIcon className="premium-attempts-icon" />
            <Typography component="h2" id="premium-attempts-title" className="premium-attempts-title">
                This is a Premium test
            </Typography>
            <Typography component="p" className="premium-attempts-message">
                {remaining === 1
                    ? 'This is your last free attempt for Premium tests. After this, you will need a subscription to attempt them.'
                    : `You have ${remaining} free attempts for Premium tests. Starting this test will use 1, leaving ${remaining - 1}.`}
            </Typography>
            <Button variant="contained" color="primary" size="medium" className="white-text premium-attempts-continue" onClick={onContinue}>
                {remaining === 1 ? 'Use my last free attempt' : 'Continue with a free attempt'}
            </Button>
            <Button variant="text" size="small" className="premium-attempts-subscribe" onClick={onSubscribe}>
                Subscribe for unlimited access
            </Button>
        </DialogContent>
    </Dialog>
);
